import React from 'react';

export default function FloatingCta() {
  return (
    <aside 
      aria-label="Hurtig kontakt"
      className="fixed bottom-6 right-6 z-40 flex flex-col items-center gap-3 select-none"
    >
      {/* Phone Call CTA */}
      <a
        href="tel:+4523964042"
        aria-label="Ring til Akut Vikaren på (+45) 23 96 40 42"
        title="Ring til os: (+45) 23 96 40 42"
        className="group relative flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#b39366] hover:bg-[#a18155] text-white shadow-lg hover:shadow-2xl shadow-[#b39366]/30 transition-all duration-300 ease-out hover:scale-110 active:scale-95 focus:outline-none focus-visible:ring-4 focus-visible:ring-[#b39366]/50"
      >
        <span className="sr-only">Ring nu</span>
        <i className="fa-solid fa-phone text-lg sm:text-xl transition-transform duration-300 group-hover:rotate-12" aria-hidden="true"></i>
        
        {/* Tooltip on hover (desktop) */}
        <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-lg bg-[#041c2c] px-3 py-1.5 text-xs font-semibold text-white opacity-0 shadow-md transition-all duration-200 group-hover:opacity-100 group-hover:-translate-x-1 hidden sm:block border border-slate-700">
          Ring: (+45) 23 96 40 42
        </span>
      </a>

      {/* Email CTA */}
      <a
        href="mailto:kontakt@akutvikaren.dk"
        aria-label="Send en e-mail til kontakt@akutvikaren.dk"
        title="Send en email: kontakt@akutvikaren.dk"
        className="group relative flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#041c2c] hover:bg-[#072c44] text-white border-2 border-[#b39366]/70 shadow-lg hover:shadow-2xl shadow-slate-950/40 transition-all duration-300 ease-out hover:scale-110 active:scale-95 focus:outline-none focus-visible:ring-4 focus-visible:ring-[#b39366]/50"
      >
        <span className="sr-only">Send email</span>
        <i className="fa-solid fa-envelope text-lg sm:text-xl text-[#b39366] transition-transform duration-300 group-hover:scale-110" aria-hidden="true"></i>

        {/* Tooltip on hover (desktop) */}
        <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-lg bg-[#041c2c] px-3 py-1.5 text-xs font-semibold text-white opacity-0 shadow-md transition-all duration-200 group-hover:opacity-100 group-hover:-translate-x-1 hidden sm:block border border-slate-700">
          kontakt@akutvikaren.dk
        </span>
      </a>
    </aside>
  );
}
